export const LANGUAGES = [
    {code: 'en', name: 'English'},
    {code: 'ar', name: 'عربي'}
];